<template>
  <tr :class="{ advanced: settingsVisible }">
    <td class="dragger">
      <img src="/img/draggable-icon.png" />
    </td>
    <td>
      <select-field
        class="input-sm"
        :id="`amount-${position}-chapter-id`"
        :name="`amount[${position}][chapterId]`"
        :value="variant.chapterId || ''"
        :items="availableChapters"
        @selected="
          (name, chapterId) =>
            $emit('chapterSelected', variant.id, 'chapterId', chapterId)
        "
      />
    </td>
    <td>
      <select-field
        class="input-sm"
        :id="`amount-${position}-category-id`"
        :name="`amount[${position}][categoryId]`"
        :value="variant.categoryId || ''"
        :items="availableCategories"
      />
    </td>
    <td
      v-for="currency in currencies"
      :key="`amount-${position}-${currency.code}`"
    >
      <price-amount
        :name="`amount[${position}][amounts][${currency.code}]`"
        :amount="variant['amounts'][currency.code] || ''"
        :currency="currency"
      />
    </td>
    <td>
      <a
        href
        class="enable-advanced-settings"
        @click.prevent="settingsVisible = !settingsVisible"
      >
        {{ lang.get('miscellaneous.advanced_search.label') }}
      </a>
    </td>
    <td>
      <span class="button-pill-close standalone">
        <a
          href
          class="deleter-action"
          @click.prevent="$emit('deleted', variant)"
        >
          <icon name="close-circle" />
        </a>
      </span>
    </td>
    <div v-show="settingsVisible" class="advanced-settings">
      <span>
        {{ lang.get('fields.form.conditional.when') }}
      </span>
      <select-field
        class="input-sm"
        :id="`amount-${position}-field-id`"
        :name="`amount[${position}][fieldId]`"
        :value="variant.fieldId"
        :items="fields"
        @selected="
          (name, fieldId) =>
            $emit('fieldSelected', variant.id, 'fieldId', fieldId)
        "
      />
      <span>
        {{ lang.get('fields.form.conditional.options.is') }}
      </span>
      <select-field
        class="input-sm"
        :id="`amount-${position}-field-value`"
        :name="`amount[${position}][fieldValue]`"
        :value="variant.fieldValue"
        :items="fieldValues[variant.fieldId] || []"
        id-property="value"
        value-property="label"
        @selected="
          (name, value) =>
            $emit('fieldValueSelected', variant.id, 'fieldValue', value)
        "
      />
    </div>
  </tr>
</template>

<script>
import { SelectField } from 'vue-bootstrap';
import Icon from '@/lib/components/Shared/Icon';
import PriceAmount from './PriceAmount';

export default {
  inject: ['lang'],
  components: {
    Icon,
    PriceAmount,
    SelectField
  },
  props: {
    variant: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: Number,
      default: 0
    },
    currencies: {
      type: Array,
      default: () => []
    },
    chapters: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    fieldValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // Initially, it makes sense to show advanced settings if the price variant
      // already has a fieldId defined.
      settingsVisible: this.variant.fieldId != null
    };
  },
  computed: {
    availableChapters() {
      const allChapters = {
        id: '',
        name: this.lang.get('payments.prices.amount_selectors.chapters')
      };

      return [allChapters, ...this.chapters];
    },
    availableCategories() {
      const allCategories = {
        id: '',
        name: this.lang.get('payments.prices.amount_selectors.categories')
      };

      if (this.variant.chapterId) {
        return [
          allCategories,
          ...this.categories.filter(category =>
            category.chapterIds.includes(this.variant.chapterId)
          )
        ];
      }

      return [allCategories, ...this.categories];
    }
  }
};
</script>

<style scoped>
.table tr.advanced {
  height: 110px;
  position: relative;
  transform: scale(1);
}

.table td {
  vertical-align: top;
}

.enable-advanced-settings {
  line-height: 1.8;
}

.advanced-settings {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 20px;
  left: 50px;
}

.advanced-settings span {
  flex: 0 0 auto;
  padding: 0 10px;
}

.advanced-settings span:first-child {
  padding-left: 0;
}
</style>
